import { AxiosError } from "axios";
import useApi from "../../common/hooks/useApi";


export default () => {
    const api = useApi({ module: "UnidadProduccion" });
    const module = "Correo";

    return {
        cargarRendiciones: async (archivosRendicion: FileList, tipoCorreo: number) => {
            try {                
                const formdata = new FormData();
                formdata.append("TipoCorreo", `${tipoCorreo}`);
                for (let i = 0; i < archivosRendicion.length; i++) {                    
                    formdata.append("Files", archivosRendicion[i]);
                }
                const response = await api.axiosInstance.post(`${module}/CargarRendicion`, formdata, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }                        
                    }
                );
                return { data:response.data };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },        
    };
}